import { Alert, Box, Divider, Drawer, DrawerProps, Stack } from "@mui/material"
import * as React from "react"
import { ErrorBoundary } from "../ErrorBoundary"
import { Label } from "../Typography/Typography"

const drawerMaxWidth = 640

interface NexDrawerProps extends DrawerProps {
    title?: string
    titleActions?: React.ReactNode
    drawerActions?: React.ReactNode
}

export const NexDrawer = ({
    title,
    titleActions,
    children,
    anchor = "right",
    drawerActions,
    ...props
}: NexDrawerProps) => {
    return (
        <Drawer anchor={anchor} variant="temporary" {...props}>
            <Stack
                sx={{
                    p: 4,
                    pb: 2,
                    maxWidth: drawerMaxWidth,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >
                {title && <Label>{title}</Label>}
                <ErrorBoundary disableNexusIcon={true} fallback={<Alert>Something went wrong!</Alert>}>
                    {titleActions}

                    <Box sx={{ flex: 1 }}>{children}</Box>

                    {drawerActions && (
                        <Box sx={{ width: 1 }}>
                            <Divider sx={{ mb: 2 }} />
                            {drawerActions}
                        </Box>
                    )}
                </ErrorBoundary>
            </Stack>
        </Drawer>
    )
}
